import { css } from '@emotion/core';

export const ClickableUserIconStyle = {
    cursor: 'pointer'
};

export const UserIconStyle = css`
    user-select: none;
`;
